export default __webpack_public_path__ + "static/media/polygon.e2b6a18a.svg";